import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'violaocatolico:auth';

function loadInitial() {
  try {
    const raw = typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { token: null, user: null };
    const parsed = JSON.parse(raw);
    return { token: parsed?.token ?? null, user: parsed?.user ?? null };
  } catch {
    return { token: null, user: null };
  }
}

function persist(state) {
  try {
    if (state.token && state.user) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ token: state.token, user: state.user }));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore quota / SSR
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: { ...loadInitial(), status: 'idle', error: null },
  reducers: {
    setCredentials(state, action) {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.status = 'authenticated';
      state.error = null;
      persist(state);
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.status = 'idle';
    },
    logout(state) {
      state.token = null;
      state.user = null;
      state.status = 'idle';
      state.error = null;
      persist(state);
    },
  },
});

export const { setCredentials, setStatus, setError, logout } = authSlice.actions;

export const selectIsAuthenticated = (state) => Boolean(state.auth.token);
export const selectCurrentUser = (state) => state.auth.user;
export const selectAuthStatus = (state) => state.auth.status;
export const selectAuthError = (state) => state.auth.error;

export default authSlice.reducer;
